export default __webpack_public_path__ + "models/99ffce3856b9292d6579fc6433e21ad9.glb";